import React from 'react';

import ButtonLink from '../../../../elements/ButtonLink';
import ToolbarLayout from '../../../../elements/ToolbarLayout';
import stylesheet from './QuestionFooter.module.scss';

const QuestionFooter = props => {
    const {settings, disabled, onVote, answerAgain, onCancelAnswerAgain, i18n} = props;

    return (
        <ToolbarLayout className={stylesheet.QuestionFooter}>
            {answerAgain ? <ButtonLink onClick={onCancelAnswerAgain}>{i18n['label.cancel']}</ButtonLink> : null}
            <ButtonLink
                onClick={onVote}
                style={{
                    borderColor: settings.header,
                    backgroundColor: settings.header,
                    color: settings.headerText,
                    flexGrow: 2,
                }}
                disabled={disabled}>
                {i18n['label.enrich.save']}
            </ButtonLink>
        </ToolbarLayout>
    );
};

export default QuestionFooter;
